import $ from 'jquery';

$(() => {
  $(document).on('click', '.favourite-btn', function () {
    const icon = $(this).find('svg');
    const isFavorited = icon.attr('fill') === '#E5C900';

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'handle_favorite_product',
        product_id: icon.data('product-id'),
        remove: isFavorited,
      },
      success: function (res) {
        if (res.success) {
          icon.attr('fill', isFavorited ? 'none' : '#E5C900');
        }
      },
    });
  });
});
